import React from "react";

function formatDate(dateValue, locale) {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return dateValue;
  return date.toLocaleDateString(locale);
}

function formatCurrencyRounded(value, locale) {
  const amount = Math.round(Number(value || 0));
  return `${amount.toLocaleString(locale)} €`;
}

export default function AgencyThankYou({ form, price, t, locale = "it-IT" }) {
  const indemnity = Number(form.amount || 0) * 0.7;
  const priceText = formatCurrencyRounded(price, locale);
  const indemnityText = formatCurrencyRounded(indemnity, locale);

  return (
    <section className="agency-thankyou">
      <p className="agency-thankyou-title">❤️ {t.thankTitle}</p>
      <p className="agency-thankyou-price">{priceText}</p>
      <p className="agency-thankyou-warning">{t.thankWarning} ⚠️</p>

      <p>{t.thankIntro}</p>

      <p>{t.quotePreview}</p>

      <ul className="agency-thankyou-list">
        <li>🗓️ {t.day}: {formatDate(form.start_date, locale)}</li>
        <li>🏰 {t.venue}: {form.location || "-"}</li>
        <li>
          🕦 {t.timeRange}: {form.start_hour || "-"} - {form.end_hour || "-"}
        </li>
        <li>💧 {t.activationThreshold}: {form.amount_rain || "5mm"}</li>
        <li>💰 {t.insuredBudget}: {formatCurrencyRounded(form.amount, locale)}</li>
        <li>💸 {t.automaticIndemnity}: {indemnityText} (70%)</li>
      </ul>

      <p>{t.thankValue.replace("{price}", priceText).replace("{indemnity}", indemnityText)}</p>

      <p className="agency-thankyou-question">
        {t.doubts} <a href="mailto:info@wedly.it">info@wedly.it</a>
      </p>
    </section>
  );
}
